import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Alert } from 'react-bootstrap';
import { Link, useParams, Navigate } from 'react-router-dom';
import LeiService from '../../../../../services/leis-auth';



const FormArquivo = () => {
    const [arquivo, setArquivo] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [ano, setAno] = useState("");
    const handleUpload = (e) => setArquivo(e.target.files[0]);

    async function pegaAno(id) {
        const response = await LeiService.leiEdit(id);
            setAno(response.data["ano"]);
    }

    useEffect(() => {
        pegaAno(id)
    }, [])

    const { id } = useParams();
    const montaForm = async () => {
        const lei = new FormData();
        lei.append("arquivo", arquivo);
        lei.append("ano", ano);
        return lei
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const lei = await LeiService.arquivo(id, ano, dados)
            if (lei.data["cod_lei"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <div className="da-espaco">
                        <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                            <Row xs={1} lg={2}>
                                <Col lg={10}>
                                    <Form.Group className="mb-3" controlId="arquivo">
                                        <Form.Label>Arquivo da Lei</Form.Label>
                                        <Form.Control
                                            required
                                            type="file"
                                            name="arquivo"
                                            onChange={handleUpload}
                                            accept="application/pdf"
                                        />
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={2}>
                                    <Button type='submit' variant='primary'>Salvar</Button>
                                </Col>
                            </Row>
                        </Form>
                        <br />
                        <Link to={'/restrito/leis/listar'}>
                            <Button variant="danger" type="button">
                                Cancelar
                            </Button>
                        </Link>
                    </div>
                </Container>
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Lei editada com sucesso!</Alert>
                <Navigate to={'/restrito/leis/listar'} />
            </Fragment>
        )
    }
}

export default FormArquivo